import axios from 'axios';
import { Toggle } from './toggle';

const resultsContainer = document.getElementById('search-results');
const searchLower = document.querySelector('.header-search__lower');
let timer;

const search = (event) => {
    if (event.target.value.length < 3) return;

    clearTimeout(timer);

    searchLower.classList.add('is-active');

    timer = setTimeout(() => {
        axios.get(`/api/search.json?query=${event.target.value}`)
            .then((response) => {
                let results = `<p class="header-search__noresults">No results for "${response.data.meta.query}"</p>`;

                if (response.data.data.length) {
                    results = response.data.data.map(result => (
                        `<li class="header-search__result">
                            <a href="${result.url}">
                                ${result.title}
                                <svg class="icon" >
                                    <use xlink:href="#arrow-right"></use>
                                </svg>
                            </a>
                            <span class="h6">${result.section}</span>
                        </li>`
                    )).join('');
                }

                resultsContainer.innerHTML = results;
            });
    }, 750);
};

export default(() => {
    const input = document.getElementById('header-search-input');
    const openSearch = Array.from(document.querySelectorAll('.js-header-search-toggle'));
    const closeSearch = Array.from(document.querySelectorAll('.js-header-search-close'));

    openSearch.forEach((el) => {
        new Toggle({
            source: el,
            target: document.documentElement,
            targetClass: 'header-search-active',
            callBack: () => {
                document.querySelector('.search-input__input').focus();
            },
        });
    });

    closeSearch.forEach((el) => {
        el.addEventListener('click', () => {
            document.documentElement.classList.remove('header-search-active');
            input.value = '';
            searchLower.classList.remove('is-active');
        });
    });

    if (input) input.addEventListener('keyup', search);
})();
